import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FaTimes } from 'react-icons/fa';
import '../../styles/components/DescriptionCompareModal.css';

const DescriptionCompareModal = ({ open, oldDescription, newDescription, onClose }) => {
  useEffect(() => {
    if (!open) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="description-compare-modal-backdrop"
      onClick={handleBackdropClick}
      role="presentation"
    >
      <div
        className="description-compare-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="description-compare-modal-title"
      >
        <button
          type="button"
          className="description-compare-modal-close"
          onClick={onClose}
          aria-label="Fechar"
        >
          <FaTimes />
        </button>

        <h3 id="description-compare-modal-title" className="description-compare-modal-title">
          Alteração de descrição
        </h3>

        <div className="description-compare-modal-grid">
          <div className="description-compare-panel">
            <span className="description-compare-panel-label">Descrição anterior</span>
            <div className="description-compare-panel-content">
              {oldDescription?.trim() ? oldDescription : '(vazia)'}
            </div>
          </div>
          <div className="description-compare-panel">
            <span className="description-compare-panel-label">Descrição nova</span>
            <div className="description-compare-panel-content">
              {newDescription?.trim() ? newDescription : '(vazia)'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DescriptionCompareModal.propTypes = {
  open: PropTypes.bool.isRequired,
  oldDescription: PropTypes.string,
  newDescription: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default DescriptionCompareModal;
